(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/views/partials/video-with-seo.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/views/partials/video-with-seo.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.emp_video_player=_cmps.emp_video_player||{};
_cmps.emp_video_player.templates=_cmps.emp_video_player.templates||{};
svs.components.emp_video_player.templates.video_with_seo = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"emp-partial\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"components-components-emp_video_player-json_ld_scripttag"),depth0,{"name":"components-components-emp_video_player-json_ld_scripttag","data":data,"indent":"  ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + ((stack1 = container.invokePartial(lookupProperty(partials,"components-components-emp_video_player-video"),depth0,{"name":"components-components-emp_video_player-video","data":data,"indent":"  ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>";
},"usePartial":true,"useData":true});
Handlebars.partials['components-components-emp_video_player-video_with_seo'] = svs.components.emp_video_player.templates.video_with_seo;
})(svs, Handlebars);

 })(window);